import styled from 'styled-components'

import Field from 'components/Form/components/Field'

export const FieldStyled = styled(Field)``
